const phoneType = {
  landLine: 'Land Line',
  mobile: 'Mobile',
  fax: 'Fax',
};

export default phoneType;
